/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import { CONF_API_BASEURL } from '../../../config';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> 'Infoalert Text --------------------------------
    infoalerttext_DE: [],
    infoalerttext_EN: [],

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Website' - 'Infoalert Text'
    ***************************************************************************/
    /***************************************************************************
    * get_InfoalertText_DE()
    *
    * Desc: Return 'DE' Version of Infoalert Text.
    * Note:
    *
    */
    get_InfoalertText_DE: state => {

        return state.infoalerttext_DE;

    }, // eof get_InfoalertText_DE()


    /***************************************************************************
    * get_InfoalertText_EN()
    *
    * Desc: Return 'EN' Version of Infoalert Text.
    * Note:
    *
    */
    get_InfoalertText_EN: state => {

        return state.infoalerttext_EN;

    }, // eof get_InfoalertText_EN()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Website' - 'Infoalert Text'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getInfoalertText()
    *
    * Desc: Save 'Infoalert Text' to state.
    * Note: Gettin 'lang' via payload.
    *
    */
    mut_call_getInfoalertText: (state, payload) => {

        if (payload.lang === 'de') {
            state.infoalerttext_DE = payload.response;
        }

        if (payload.lang === 'en') {
            state.infoalerttext_EN = payload.response;
        }

    }, // eo function mut_call_getInfoalertText()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Website' - 'Infoalert Text'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getInfoalertText'
    *
    * Desc: Get 'Infoalert Text'.
    * Note: Gettin 'lang' in payload.
    *
    */
    actn_call_getInfoalertText: (context, payload) => {

        // Vue.prototype.$vp_m();
        axios.post(CONF_API_BASEURL, payload.payload)
            .then(function (response) {
                // Vue.prototype.$vp_um();
                context.commit('mut_call_getInfoalertText', { response: response.data.data.infoalert, lang: payload.lang });
            })
            .catch(function (error) {
                // Vue.prototype.$vp_um();


                // >>> --------------------------
                if (error.response && error.response.data.errors) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: error.response.data.errors[0].message
                    });
                } else {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: "Service not available"
                    });
                }
            });

    }, // eo funtion actn_call_getInfoalertText()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/infoalert/infoalert.js